






































































































import {Component, Vue} from 'vue-property-decorator';
import signalDiagramModule from '@/store/modules/signalDiagramModule';
import spectrumDiagramModule from '@/store/modules/spectrumDiagramModule';
import Card from '@c/Card.vue';
import {uuidv4} from '@/utils/uuidUtils';
import {
  PModuleWithMeasurements,
  PModuleEvent,
  DtcpAccelerometerModule,
} from '@/views/system/modules/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import SpectrumDiagramBox from '@c/diagrams/SpectrumDiagramBox.vue';
import AngleDiagramBox from '@c/diagrams/AngleDiagramBox.vue';
import RawDiagramBox from '@c/diagrams/RawDiagramBox.vue';
import {getSignalDiagramTitle, getSpectrumDiagramTitle} from '@c/diagrams/utils';
import {SignalDiagramData, SpectrumDiagramData, AngleDiagramData} from '@c/diagrams/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {
  pmoduleStoresByTypeMap,
  pmoduleEventBoundaryPassedDataRoutesByTypeMap,
} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import {groupBy} from 'lodash';
import {PMEventType} from '@/views/system/modules/enums';
import PModuleButtons from './PModuleButtons.vue';
import {httpClient} from '@api/baseApi';
import {Freqband as FreqbandType} from '@/interfaces/diagrams';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';

type Freqband = FreqbandType & {isThreeDoctave: boolean};
@Component({
  components: {
    SignalDiagramBox,
    SpectrumDiagramBox,
    RawDiagramBox,
    AngleDiagramBox,
    Card,
    Loading,
    PModuleButtons,
  },
})
export default class DtcpAccelerometerPModuleView extends Vue {
  // Программный модуль
  pmodule: PModuleWithMeasurements | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  // Диаграммы сигналов
  signalDiagrams: {diagram: SignalDiagramData; comparedDiagrams: SignalDiagramData[]}[] = [];

  // Диаграммы спектров
  spectrumDiagrams: {
    diagram: SpectrumDiagramData;
    comparedDiagrams: SpectrumDiagramData[];
    freqbands: any;
    freqband: any;
  }[] = [];

  // Диаграммы сырых сигналов
  rawDiagrams: {diagram: SpectrumDiagramData; comparedDiagrams: SpectrumDiagramData[]}[] = [];

  angleDiagram: AngleDiagramData | null = null;

  // События ПМ
  events: PModuleEvent[] = [];

  freqbands: Freqband[] = [];
  dtcpAccelerometerModules: any = {};

  get span_nodes() {
    return this.pmodule?.span_nodes?.filter((n: any) => !n.is_deleted);
  }

  // Компоненты отображения диаграмм спектров
  get diagramBoxes() {
    return this.$refs['diagrams'] as SpectrumDiagramBox[];
  }
  obtainSpectrum(ts: number | undefined | null) {
    if (ts)
      this.diagramBoxes.forEach((d: SpectrumDiagramBox) => {
        d.setDiagrams(Math.trunc(ts));
      });
  }

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      ((this as any).$route.meta.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  getSpectrumTitle(fregband: Freqband) {
    if (fregband == null) return 'Спектр низких частот';
    return `Спектр огибающей (центральная частота ${fregband.central_frequency}, ширина полосы ${fregband.bandwidth})`;
  }

  getChartTitle(title: string) {
    return title.split(' оси')[0];
  }

  // Получить измерение по id
  getMeasurementById(id: number) {
    const data = measurementsModule.all.filter(x => x.id === id);
    if (data.length) return data[0];
    return null;
  }

  // Получить наименование для строки таблицы freqband в зависимости от значений в ней
  getNameFreqbandItem(central_frequency?: number, bandwidth?: number) {
    const cf = central_frequency ? `ц.ч. ${central_frequency}` : '';
    const bw = bandwidth ? `ш.п. ${bandwidth}` : '';
    return cf ? `${cf}${bw ? ';' : ''} ${bw}` : bw;
  }

  envelopeDoctaveItems(
    name: 'envelope_3doctave' | 'envelope_1doctave',
  ): {central: number; width: number; isThreeDoctave: boolean}[] {
    if (!this.pmodule) {
      return [];
    }

    const base2 = (this.pmodule as DtcpAccelerometerModule)[name].toString(2);
    const base2Length = base2.length - 1;
    let data: any[] = [];
    const module = this.dtcpAccelerometerModules.find(
      (item: any) => item.id === (this.pmodule as DtcpAccelerometerModule).sensor_type,
    );
    if (module) {
      data = module[name];
    }

    data = data
      .map(item => {
        return {
          ...item,
          isActive: base2[base2Length - item.bit] === '1',
          width: item.max - item.min,
          isThreeDoctave: name === 'envelope_3doctave',
        };
      })
      .filter(item => item.isActive);

    return data;
  }

  get envelopeThreeDoctaveItems() {
    return this.envelopeDoctaveItems('envelope_3doctave');
  }

  get envelopeOneDoctaveItems() {
    return this.envelopeDoctaveItems('envelope_1doctave');
  }

  // TODO: Вынести этот код в mixin
  async created() {
    try {
      await measurementsModule.fetchAll();
      const {data} = await this.apiStore.getById(this.$route.params.id);
      const {data: dtcpAccelerometerModules} = await httpClient.get(
        `/dtcp-accelerometer-modules/sensor-types/`,
      );
      this.dtcpAccelerometerModules = dtcpAccelerometerModules;
      this.pmodule = data as PModuleWithMeasurements;
      this.freqbands = [...this.envelopeThreeDoctaveItems, ...this.envelopeOneDoctaveItems].map(
        item => {
          return {
            id: Math.random(),
            central_frequency: item.central,
            bandwidth: item.width,
            name: this.getNameFreqbandItem(item.central, item.width),
            isThreeDoctave: item.isThreeDoctave,
          };
        },
      );

      if (!this.pmodule) return;

      if (this.pmodule.span_nodes) {
        if (!dtcpTahoModule.all.length) {
          await dtcpTahoModule.fetchAll();
        }
        this.pmodule.span_nodes = this.pmodule.span_nodes.map((n: any) => {
          if (n.is_deleted) return n;
          if (!n.taho_module_uuid) return n;
          const taho = dtcpTahoModule.all.find(m => m.guid == n.taho_module_uuid);
          const newval = {
            ...n,
            taho_module: taho,
          };
          return newval;
        });
      }

      const signalDiagramMeasurements: any[] = [];
      const spectrumDiagramMeasurements: any[] = [];
      const angleMeasurements: any[] = [];
      const rawDiagramMeasurements: any[] = [];
      this.pmodule.measurements.forEach(x => {
        if (!x.measurementId) return;
        const measurement = this.getMeasurementById(x.measurementId);
        if (!measurement) return;

        if (
          measurement.type === MeasurementType.Signal &&
          !measurement.alias.includes('angle') &&
          !measurement.alias.includes('amplitude')
        ) {
          const moduleId = this.pmodule?.id as number;
          const moduleGUID = this.pmodule?.guid as string;
          const moduleType = this.pmodule?.type as PModuleType;
          signalDiagramMeasurements.push({
            id: uuidv4(),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            name: getSignalDiagramTitle(measurement),
            measurement: measurement,
            topBoundary: x.topWarningBoundary,
            bottomBoundary: x.bottomWarningBoundary,
            groupAlias: measurement.alias?.split('_')[0],
          });
        }
        if (measurement.type === MeasurementType.Spectrum) {
          const moduleId = this.pmodule?.id as number;
          const moduleGUID = this.pmodule?.guid as string;
          const moduleType = this.pmodule?.type as PModuleType;

          spectrumDiagramMeasurements.push({
            id: uuidv4(),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            name: getSpectrumDiagramTitle(measurement),
            measurement: measurement,
          });
        }

        if (measurement.type === MeasurementType.Raw) {
          const moduleId = this.pmodule?.id as number;
          const moduleGUID = this.pmodule?.guid as string;
          const moduleType = this.pmodule?.type as PModuleType;
          rawDiagramMeasurements.push({
            id: uuidv4(),
            moduleId: moduleId,
            moduleGUID: moduleGUID,
            moduleType: moduleType,
            name: getSpectrumDiagramTitle(measurement),
            measurement: measurement,
          });
        }

        if (measurement.alias.includes('angle') || measurement.alias.includes('amplitude')) {
          angleMeasurements.push(measurement);
        }
      });

      if (angleMeasurements.length != 0) {
        const moduleId = this.pmodule?.id as number;
        const moduleGUID = this.pmodule?.guid as string;
        const moduleType = this.pmodule?.type as PModuleType;

        this.angleDiagram = {
          id: uuidv4(),
          name: 'Диаграмма отображения угла фазы',
          moduleId: moduleId,
          moduleGUID: moduleGUID,
          moduleType: moduleType,
          measurements: angleMeasurements,
        };
      }

      // TODO: Изменить условие группировки, когда будут сделаны специальные измерения
      const grouppedSignalMeasurements = groupBy(signalDiagramMeasurements, x => x.groupAlias);

      Object.keys(grouppedSignalMeasurements).forEach((x: any) => {
        const values = grouppedSignalMeasurements[x];
        this.signalDiagrams.push({
          diagram: values[0],
          comparedDiagrams: values.slice(1),
        });
      });

      const grouppedSpectrumMeaurements = groupBy(
        spectrumDiagramMeasurements,
        x => x.measurement.spectrumType,
      );

      Object.keys(grouppedSpectrumMeaurements).forEach((x: any) => {
        const values = grouppedSpectrumMeaurements[x];
        this.spectrumDiagrams.push({
          diagram: values[0],
          freqbands: this.freqbands,
          freqband: null,
          comparedDiagrams: values.slice(1),
        });
      });

      if (rawDiagramMeasurements.length) {
        const [diagram, ...comparedDiagrams] = rawDiagramMeasurements;
        this.rawDiagrams.push({
          diagram,
          comparedDiagrams,
        });
      }

      if (this.signalDiagrams)
        signalDiagramModule.setCanSync({diagrams: [...this.signalDiagrams.map(x => x.diagram)]});

      if (this.spectrumDiagrams) {
        this.spectrumDiagrams = this.spectrumDiagrams.flatMap(spectrumDiagram => {
          if (spectrumDiagram.diagram.measurement.spectrumType === 1) {
            return this.freqbands.map(freqband => ({
              diagram: {
                id: uuidv4(),
                moduleId: spectrumDiagram.diagram.moduleId,
                moduleGUID: spectrumDiagram.diagram.moduleGUID,
                moduleType: spectrumDiagram.diagram.moduleType,
                name:
                  spectrumDiagram.diagram.name +
                  ` (${freqband.central_frequency}/${freqband.bandwidth})`,
                measurement: spectrumDiagram.diagram.measurement,
                freqbandId: freqband.id,
              },
              freqbands: [freqband],
              freqband: freqband,
              comparedDiagrams: spectrumDiagram.comparedDiagrams,
            }));
          }
          return [spectrumDiagram];
        });

        spectrumDiagramModule.setCanSync({
          diagrams: [...this.spectrumDiagrams.map(x => x.diagram)],
        });
      }

      this.events = await this.apiStore.getEventTypes();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async actionRaw() {
    // Отправка акшена на сохранение текущего сырого сигнала
    if (this.pmodule) {
      await httpClient.put(
        `dtcp-accelerometer-modules/${this.pmodule.id}/actions/store_raw_data`,
        null,
        {
          params: {},
        },
      );
    }
    alert('Запрос на сохранение сырых данных с датчика отправлен в систему');
  }

  async actionSpectrum() {
    // Отправка запроса на сохранение текущего спектра
    if (this.pmodule) {
      await httpClient.put(
        `dtcp-accelerometer-modules/${this.pmodule.id}/actions/store_spectrum`,
        null,
        {
          params: {},
        },
      );
    }
    alert('Запрос на сохранение спектра с датчика отправлен в систему');
  }

  // Проверяем есть ли у модуля событие "Выход за границу"
  get isLink() {
    return (
      this.pmodule &&
      this.events.filter((e: PModuleEvent) => e.type === PMEventType.BoundaryPassed)[0]
    );
  }

  /*
    Переход на страницу показа события "Выход за границу"
  */
  async link() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: pmoduleEventBoundaryPassedDataRoutesByTypeMap.get(this.pmodule?.type),
      params: {id: `${this.pmodule?.id}`},
    });
    window.open(href, '_blank');
  }

  beforeDestroy() {
    signalDiagramModule.clear();
    spectrumDiagramModule.clear();
  }
}
